// extracted by mini-css-extract-plugin
module.exports = {"content":"_2ijcE","body":"_3AvXZ","no-padding":"_3XM5p","noPadding":"_3XM5p","with-padding":"_1oU1b","withPadding":"_1oU1b"};